import { useContext, useState } from "react";

import TableContext from "context/table/tableContext";

import Header from "./Header";
import Tasks from "./Tasks";
import { TaskTableData } from "./types";

const TaskGroupDetails = () => {
    const { detailsData } = useContext(TableContext);

    const [taskTableData, setTaskTableData] = useState<TaskTableData>({
        rows: [],
        totalRows: 0,
        isInnerTableLoading: true
    });

    const getTaskTableData = (data: TaskTableData) =>
        setTaskTableData({ ...taskTableData, ...data });

    return (
        <>
            <Header key={detailsData.id} taskTableData={taskTableData} />
            <Tasks getTaskTableData={getTaskTableData} />
        </>
    );
};

export default TaskGroupDetails;
